import { render, staticRenderFns } from "./mod1.vue?vue&type=template&id=7d971f0e&scoped=true&"
import script from "./mod1.vue?vue&type=script&lang=js&"
export * from "./mod1.vue?vue&type=script&lang=js&"
import style0 from "./mod1.vue?vue&type=style&index=0&id=7d971f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d971f0e",
  null
  
)

export default component.exports